import { gsap } from '@gsap/shockingly';

const contactModal = {
	ui: {},

	modal_tl: gsap.timeline({ paused: true }),

	tween_formList: {},
	tween_formView: {},
	tween_backToFormList: {},

	init: function() {
		this.bindUI();
		this.bindAnim();
		this.bindEvents();

		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has('contact_modal') && urlParams.get('contact_modal') === 'contact') {
			this.openModal();
		}
	},

	bindUI: function() {
		this.ui.$contactModal = document.querySelector('.js-contactModal');
		this.ui.$contactModal_backdrop = document.querySelector('.js-contactModal-backdrop');
		this.ui.$contactModal_open = document.querySelectorAll('.js-contactModal-open');
		this.ui.$contactModal_close = document.querySelector('.js-contactModal-close');

		this.ui.$backToFormList = document.querySelectorAll('.js-contactModal-backToFormList');
		this.ui.$formList = document.querySelector('.js-contactModal-formList');
		this.ui.$formView = document.querySelector('.js-contactModal-formView');
		this.ui.$formView_description = document.querySelector('.js-contactModal-formView-description');
		this.ui.$formView_subIntro = document.querySelector('.js-contactModal-formView-subIntro');
		this.ui.$formView_icon = document.querySelector('.js-contactModal-formView-icon');
		this.ui.$formView_input_formType = document.querySelector('input[data-input-name=form_type]');
	},

	bindAnim: function() {
		this.modal_tl
			.to('.js-contactModal-backdrop', {autoAlpha: 1, duration: .3})
			.fromTo('.js-contactModal', {xPercent: 100}, {xPercent: 0, autoAlpha: 1, duration: .4, ease: "elastic.out(1, 1)"});


		this.tween_formList = gsap.to(".js-contactModal-formList", {
			xPercent: -100,
			autoAlpha: 0,
			duration: .7,
			ease: "back.inOut(1.5)",
			paused: true
		})
		this.tween_formView = gsap.fromTo(".js-contactModal-formView", {
			display: "none",
			xPercent: 100,
			autoAlpha: 0
		}, {
			display: "block",
			xPercent: -100,
			autoAlpha: 1,
			duration: .7,
			ease: "back.inOut(1.5)",
			paused: true
		})
		this.tween_backToFormList = gsap.fromTo(".js-contactModal-backToFormList", {
			scale: 0,
			autoAlpha: 0
		}, {
			scale: 1,
			autoAlpha: 1,
			duration: .5,
			ease: "power4.out",
			paused: true
		});
	},

	bindEvents: function() {
		this.ui.$contactModal_open.forEach(openButton => {
			openButton.addEventListener('click', this.openModal.bind(this));
		});
		this.ui.$contactModal_backdrop.addEventListener('click', this.closeModal.bind(this));
		this.ui.$contactModal_close.addEventListener('click', this.closeModal.bind(this));

		this.ui.$backToFormList.forEach(item => {
			item.addEventListener('click', this.backToFormList.bind(this));
		});

		this.bindEvents_selectForm();
	},

	bindEvents_selectForm: function() {
		document.querySelectorAll('.js-contactModal-selectForm').forEach(item => {
			item.addEventListener('click', this.selectForm.bind(this));
		});
	},

    openModal: function(e) {
		if (e) {
			e.preventDefault();
		}
		this.modal_tl.play();
		this.ui.$contactModal.classList.add('is-opened');
    },

    closeModal: function() {
		this.modal_tl.reverse();
		this.ui.$contactModal.classList.remove('is-opened');
    },

	selectForm: function(e) {
		if(!this.ui.$contactModal.classList.contains('is-opened')){
			this.openModal();
		}

		let formDatas = JSON.parse(decodeURIComponent(e.currentTarget.getAttribute('data-form-datas')));

		this.ui.$formView_description.innerHTML = formDatas.form_intro;
		this.ui.$formView_subIntro.innerHTML = formDatas.form_intro_sub;
		this.ui.$formView_input_formType.value = formDatas.form_type;

		this.ui.$formView_icon.classList.forEach((classItem) => {
			if (/icon-\S+/.test(classItem)) {
				this.ui.$formView_icon.classList.replace(classItem, 'icon-' + formDatas.icon);
			}
		});
		this.ui.$formView_icon.querySelector('use').setAttribute('href', '#icon-' + formDatas.icon);

		this.tween_formList.play();
		this.tween_formView.play();
		this.tween_backToFormList.play();
    },

	backToFormList: function(e) {
		this.tween_formList.reverse();
		this.tween_formView.reverse();
		this.tween_backToFormList.reverse();
    },

};

export default contactModal;
